import React from 'react';

import { Button, Form, Input, Divider } from 'semantic-ui-react';

import { shouldFieldBeRed, isFormValid } from "../../helpers";

// Import Component style
import "./LoginForm.css";
import PasswordInput from '../UI/PasswordInput/PasswordInput';


const LoginForm = (props) => {
    const { onLogIn, onForgotPassword, handleChange } = props;
    const {username, password} = props.form;

    return (
        <Form onSubmit={onLogIn}>
            <Form.Field error={shouldFieldBeRed(username)}>
                <Input
                    id="username"
                    icon="user"
                    placeholder='E-mail'
                    name="username"
                    type="email"
                    value={username.value}
                    onChange={handleChange} />
            </Form.Field>
            <Form.Field>
                <PasswordInput
                    id="password"
                    name="password"
                    placeholder="Mot de passe"
                    value={password.value}
                    onChange={handleChange} />
            </Form.Field>

            <Button type="submit" fluid className="barestho-btn-secondary" disabled={!isFormValid(props.form)}>Connexion</Button>

            <Divider hidden />

            <a className="barestho-forgot-password-link" onClick={onForgotPassword}>Avez-vous oublié votre mot de passe?</a>
        </Form>
    );
};

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/Authentication/LoginForm.js